/*
 * language Actions
 *
 * @version 1.0.0
 * @author tfrazzet
 * @since 21-Oct-2024
 */

import { createAction } from './index'

export const actionTypes = {
  DO_LANGUAGE_CHANGE: '@@language/language_change'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name LanguageChange
 * @return {object} - The payload object
 */
export const doLanguageChange = payload => createAction(actionTypes.DO_LANGUAGE_CHANGE, { payload })

// @generator action
